module.exports = __webpack_public_path__ + "static/media/camera.db742706.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/camera.svg
// module id = 1247
// module chunks = 0